import React from "react";
import { FormattedMessage } from 'react-intl';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import MainLayout from 'components/presenters/layouts/main/MainLayout';
import NoContent from "components/widgets/NoContent/NoContent";

import RecordingsGridContainer from "./components/RecordingsGridContainer/RecordingsGridContainer";
import { useRecordingsGrid } from "./hooks/useRecordingsGrid";
import { COMPONENT_NAME } from "./constants";

import styles from './RecordingsGrid.module.scss';

function RecordingsGrid({ referenceId }: { referenceId: string }){
  const type = UIDAPresentationTypeEnum.npvr;
  const {
    data,
    settings,
    wrapperRef,
    notValidPageTitle,
    shouldShowEmptyContent
  } = useRecordingsGrid(referenceId);
  const shouldShowNoContent = !referenceId || !settings;

  if (shouldShowNoContent) {
    return (
      <MainLayout>
        <NoContent title={notValidPageTitle} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div ref={wrapperRef} className={styles.wrapper}>
        <FormattedMessage
          defaultMessage={settings.title}
          id={`${COMPONENT_NAME}.title.${settings.title}`}
          tagName='h3'
        />
        {shouldShowEmptyContent ? (
          <p className={styles.noRecordings}>
            <FormattedMessage defaultMessage='No recordings' id={`${COMPONENT_NAME}.noRecordingsText`} />
          </p>
        ): (
          <RecordingsGridContainer data={data} type={type} settings={settings} />
        )}

      </div>
    </MainLayout>
  );
}

export default React.memo(RecordingsGrid);
